import type { InferOutput } from 'valibot'
import { array, nullish, object, pipe, regex } from 'valibot'
import {
  datetimeData,
  richTextData,
  selectionData,
  singleLineData,
  videosData,
} from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'
import { crystallizeDefaultFolderSchema } from '~/utils/crystallize/folder'

export const videoTimestampSchema = pipe(
  singleLineData,
  regex(/^\d{2,3}:[0-5]\d$/),
)

export const tutorialVideoSchema = crystallizeDocumentSchema(
  'tutorial-video',
  object({
    title: nullish(singleLineData),
    description: nullish(richTextData),
    published: nullish(datetimeData),
    theme: nullish(selectionData),
    video: nullish(videosData),
    chapters: nullish(
      array(object({
        label: nullish(singleLineData),
        timestamp: nullish(videoTimestampSchema),
      })),
    ),
  }),
)

export const tutorialVideosSchema = crystallizeDefaultFolderSchema(tutorialVideoSchema)

export type TutorialVideo = InferOutput<typeof tutorialVideoSchema>

export function getSrc(doc: TutorialVideo | undefined | null): string | null {
  return doc?.components?.video?.firstVideo?.src || null
}
